import styled from 'styled-components';

const DropDownView = styled.div<{ align?: string }>`
  min-width: 320px;
  position: absolute;
  top: 4.5em;
  left: 0;
  right: 0;
  background-color: var(--gray0);
  box-shadow: 0 0.25em 0.625em rgba(53,118,172,0.15);
  z-index: 1070;
  &:before {
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 0.375em 0.5em 0.375em;
    border-color: transparent transparent var(--gray0) transparent;
    position: absolute;
    transition: all 0.3s ease-in-out;
    left: ${props => props.align === 'right' ? 'calc(50% + 2em)' : '2em'};
    top: -0.5em;
  }
`;

export default DropDownView;
